import { Link } from "react-router-dom";

const links = [
  { label: "Linen Curtains Guide", path: "/products/linen-curtains" },
  { label: "Wood Coffee Tables", path: "/products/wood-coffee-tables" },
  { label: "Beige Throw Pillows", path: "/products/beige-throw-pillows" },
  { label: "Style Guide", path: "/style-guide" },
];

export default function SANBottomCTA() {
  return (
    <section className="py-24 bg-[#2C2825]">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16 text-center">
        <p
          className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-5"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Explore More
        </p>
        <h2
          className="text-white text-3xl md:text-5xl mb-5"
          style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
        >
          More Guides for a Calm Home
        </h2>
        <p
          className="text-white/50 text-sm leading-relaxed max-w-md mx-auto mb-14"
          style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
        >
          Every piece matters. Explore our curated guides to build a home that feels considered from every angle.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          {links.map((link) => (
            <Link
              key={link.label}
              to={link.path}
              className="inline-flex items-center gap-2 border border-white/20 text-white/70 px-7 py-3 rounded-full text-xs tracking-[0.15em] hover:bg-white hover:text-[#2C2825] transition-all duration-300 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {link.label}
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-arrow-right-line text-[11px]" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
